import * as React from 'react';
import {
    Typography,
    Tabs,
    Tab,
    Box,
    Paper,
    useMediaQuery,
    useTheme
} from "@mui/material";

import _ from "lodash"
import { typography } from "../styles/globals.js"
import { business_profile_tabs } from '../mock.js';
import OverviewTab from "../components/BusinessProfileTab/OverviewTab.js"
import AssociatedPeopleTab from "../components/AssociatedPeopleTab/AssociatedPeopleTab.js"
import AddressesTab from "../components/AddressesTab/AddressesTab.js"
import WebPresenceTab from "../components/WebPresenceTab/WebPresenceTab.js"
import EmailTab from "../components/EmailTab/EmailTab.js"
import PhoneTab from "../components/PhoneTab/PhoneTab.js"
import MainWebsiteTab from "../components/MainWebsiteTab/MainWebsiteTab.js"
import LitigationsTab, { getLitigationsDisplayCount } from "../components/LitigationsTab/LitigationsTab.js"
import LiensTab, { getLiensDisplayCount } from "../components/LiensTab/LiensTab.js"


const styles = {
    container: {
        width: '100%',
        p: 2, mb: 2
    },
    headerCard: {
        marginBottom: 24
    },
    cardHeader: {
        gap: 8,
        paddingBottom: 16,
        p: 2,
        mb: 2,
    },
    tabLabel: {
        display: "flex",
        alignItems: "center",
        gap: "5px",
        flexWrap: "nowrap",
        whiteSpace: "nowrap",
    },
    tabIcon: {
        fontSize: 16
    },
    tabContainer: {
        borderBottom: 1,
        borderColor: 'divider'
    },
    tabLabelSelection: {
        '& .MuiTabs-indicator': {
            backgroundColor: '#1976d2', // selected tab color underlined
            height: 3
        },
        '& .MuiTabs-flexContainer': {
            justifyContent: 'flex-start',
            flexWrap: 'wrap'
        },
        '& .MuiTab-root': {
            color: '#0E1944', // Default tab text color
            textTransform: 'none', // Override Material-UI's default uppercase transform
            '&.Mui-selected': {
                color: '#0E1944', // Selected tab text color (same as default)
            }
        }
    },

}




const TabPanel = ({ children, value, index, sx, id }) => (
    <Box
        role="tabpanel"
        hidden={value !== index}
        sx={{ mt: 2, ...sx }}
        id={id}
    >
        {children}
    </Box>
);



export const BusinessProfileView = ({ company_details, entity, ubos, liens, litigations, branch_data, title, activeTab: externalActiveTab, onTabChange, graphData, onUpdateUbos, onUpdateGraph, onCombinedUpdate, onUpdateAddresses, onUpdateWebPresence, onUpdatePhones, onUpdateEmails, onUpdateLiens, onUpdateLitigations, onUpdateEntity }) => {
    const [internalActiveTab, setInternalTab] = React.useState(0);
    // Use external activeTab if provided, otherwise use internal state
    const activeTab = externalActiveTab !== undefined ? externalActiveTab : internalActiveTab;
    const setTab = onTabChange || setInternalTab;
    const [selectedState, setSelectedState] = React.useState(entity.state_code)

    // when window resizes, make the tab bar scrollable
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    // need to keep event parameter to have tab selection highlighted since need to access
    // Material Design's class
    const handleChange = (event, newValue) => {
        setTab(newValue);
    };

    const handleStateChange = (event) => {
        setSelectedState(event.target.value);
    };

    const getCurrentBusinessData = () => {

        // If selected state matches main entity, return main entity data
        if (selectedState === entity?.state_code) {
            return {
                id: entity?.state_code || '',
                businessName: entity?.legal_name || '',
                status: entity?.status || '',
                stateId: entity?.state_id || '',
                stateCode: entity?.state_code || '',
                registeredAgent: entity?.registered_agent?.name || '',
                incorporationDate: entity?.incorporation_date ? entity.incorporation_date.split('T')[0] : '',
                url: entity?.oc_url || '',
                ein: entity?.ein || '',
                dba: (entity?.dba_names || []).join(', ') || '',
                primaryAddress: (() => {
                    if (!company_details?.addresses?.length) return '';
                    // SOS REGISTERED ADDRESS

                    // Priority 1: SOS registered address (REGISTERED_AGENT_ADDRESS)
                    const sosRegisteredAddress = company_details.addresses.find(addr =>
                        addr.association_type?.includes('SOS_REGISTERED_ADDRESS')
                    );
                    if (sosRegisteredAddress) return sosRegisteredAddress.value;

                    // Priority 2: REGISTERED_AGENT_ADDRESS
                    const registeredAgentAddress = company_details.addresses.find(addr =>
                        addr.association_type?.includes('REGISTERED_AGENT_ADDRESS')
                    );
                    if (registeredAgentAddress) return registeredAgentAddress.value;

                    // Fallback: First available address
                    return company_details.addresses[0]?.value || '';
                })(),
                email: company_details?.emails?.[0]?.value || '',
                isInputEmail: company_details?.emails?.[0]?.association_type?.includes('INPUT_DATA') || false,
                phone: company_details?.phones?.[0]?.value || '',
                isInputPhone: company_details?.phones?.[0]?.association_type?.includes('INPUT_DATA') || false,
                website: company_details?.web_presence?.find(item => item?.type === 'DOMAIN')?.value || '',
                isInputWebsite: company_details?.web_presence?.find(item => item?.type === 'DOMAIN')?.association_type?.includes('INPUT_DATA') || false,
                selectedState: entity?.state_code || ''
            };
        }

        // Otherwise, find matching branch data
        const branchEntity = branch_data?.find(branch => branch.state_code === selectedState);
        if (branchEntity) {
            return {
                id: branchEntity.state_code || '',
                businessName: branchEntity.legal_name || '',
                status: branchEntity.status || '',
                stateId: branchEntity.state_id || '',
                stateCode: branchEntity.state_code || '',
                registeredAgent: branchEntity.registered_agent?.name || '',
                incorporationDate: branchEntity.incorporation_date ? branchEntity.incorporation_date.split('T')[0] : '',
                url: branchEntity.oc_url || '',
                ein: branchEntity.ein || '',
                dba: (branchEntity.dba_names || []).join(', ') || '',
                primaryAddress: '', // Keep main entity's contact info
                email: company_details?.emails?.[0]?.value || '',
                isInputEmail: company_details?.emails?.[0]?.association_type?.includes('INPUT_DATA') || false,
                phone: company_details?.phones?.[0]?.value || '',
                isInputPhone: company_details?.phones?.[0]?.association_type?.includes('INPUT_DATA') || false,
                website: company_details?.web_presence?.find(item => item?.type === 'DOMAIN')?.value || '',
                isInputWebsite: company_details?.web_presence?.find(item => item?.type === 'DOMAIN')?.association_type?.includes('INPUT_DATA') || false,
                selectedState: branchEntity.state_code || ''
            };
        }

        // Fallback to main entity data
        return {
            id: entity?.state_code || '',
            businessName: entity?.legal_name || '',
            status: entity?.status || '',
            stateId: entity?.state_id || '',
            stateCode: entity?.state_code || '',
            registeredAgent: entity?.registered_agent?.name || '',
            incorporationDate: entity?.incorporation_date ? entity.incorporation_date.split('T')[0] : '',
            url: entity?.oc_url || '',
            ein: entity?.ein || '',
            dba: (entity?.dba_names || []).join(', ') || '',
            primaryAddress: company_details?.addresses?.[0]?.value || '',
            email: company_details?.emails?.[0]?.value || '',
            isInputEmail: company_details?.emails?.[0]?.association_type?.includes('INPUT_DATA') || false,
            phone: company_details?.phones?.[0]?.value || '',
            isInputPhone: company_details?.phones?.[0]?.association_type?.includes('INPUT_DATA') || false,
            website: company_details?.web_presence?.find(item => item?.type === 'DOMAIN')?.value || '',
            isInputWebsite: company_details?.web_presence?.find(item => item?.type === 'DOMAIN')?.association_type?.includes('INPUT_DATA') || false,
            selectedState: entity?.state_code || ''
        };
    };

    const businessData = getCurrentBusinessData();

    // Get all available states (main entity + branches)
    const getAvailableStates = () => {
        const states = entity.state_code ? [entity.state_code] : [];

        // Add branch states if they exist
        if (branch_data && branch_data.length > 0) {
            branch_data.forEach(branch => {
                if (branch.state_code && !states.includes(branch.state_code)) {
                    states.push(branch.state_code);
                }
            });
        }

        return states;
    };

    const availableStates = getAvailableStates();

    const getTabNumber = (label, id) => {
        if (id === "phone-tab-profile") {
            return `${label} (${company_details.phones?.length || 0})`
        }
        if (id === "email-tab-profile") {
            return `${label} (${company_details.emails?.length || 0})`
        }
        if (id === "web-presence-tab-profile") {
            const domainCount = _.filter(company_details.web_presence, item => item.type !== 'DOMAIN')?.length || 0;
            return `${label} (${domainCount})`
        }
        if (id === "addresses-tab-profile") {
            return `${label} (${company_details.addresses?.length || 0})`
        }
        if (id === "associated-tab-profile") {
            return `${label} (${ubos?.length || 0})`
        }
        if (id === "overview-tab-profile") {
            return label
        }
        if (id === "main-website-tab-profile") {
            const domainCount = _.filter(company_details.web_presence, item => item.type === 'DOMAIN')?.length || 0;
            return domainCount > 0 ? `${label} (${domainCount})` : label;
        }
        if (id === "litigations-tab-profile") {
            const totalFindings = getLitigationsDisplayCount(litigations, entity, ubos);
            return `${label} (${totalFindings})`;
        }
        if (id === "liens-tab-profile") {
            const totalLiens = getLiensDisplayCount(litigations, liens, entity, ubos);
            return `${label} (${totalLiens})`;
        }
        return label
    }
    return (
        <Paper variant="outlined" sx={{ p: 2, mb: 2, borderRadius: 2, border: '1px solid #D9DDF0' }}>
            <Box sx={styles.h3} my={1}>
                <Typography sx={{ fontWeight: typography.fontWeights.semibold, fontSize: typography.fontSizes.h3 }}>
                    {title}
                </Typography>
            </Box>
            <Box sx={styles.tabContainer}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="business profile information tabs"
                    variant={isSmallScreen ? "scrollable" : "fullWidth"}
                    scrollButtons="auto"
                    sx={styles.tabLabelSelection}
                >
                    {_.map(business_profile_tabs, ({ id, label, iconPlaceholder }) => {
                        return (
                            <Tab key={id} label={
                                <Box style={styles.tabLabel}>
                                    <Typography sx={{ fontSize: typography.fontSizes.base, fontWeight: typography.fontWeights.regular }}>
                                        {getTabNumber(label, id, businessData, company_details) ? (getTabNumber(label, id, businessData, company_details)) : ''}
                                    </Typography>
                                    {/* {iconPlaceholder === "alert" ? <AlertTriangleIcon sx={{ ...styles.tabIcon, color: colors.warning }} /> : <CheckCircleIcon sx={{ ...styles.tabIcon, color: colors.success }} />} */}

                                </Box>}
                            />
                        )
                    })}
                </Tabs>
            </Box>

            <TabPanel value={activeTab} index={0} id="overview-tab-profile">
                <OverviewTab
                    businessData={businessData}
                    selectedState={selectedState}
                    onStateChange={handleStateChange}
                    availableStates={availableStates}
                />
            </TabPanel>

            <TabPanel value={activeTab} index={1} id="associated-tab-profile">
                <AssociatedPeopleTab
                    associated_people={ubos}
                    graphData={graphData}
                    onUpdateUbos={onUpdateUbos}
                    onUpdateGraph={onUpdateGraph}
                    onCombinedUpdate={onCombinedUpdate}
                />
            </TabPanel>

            <TabPanel value={activeTab} index={2} id="address-tab-profile">
                <AddressesTab addresses={company_details.addresses} onUpdateAddresses={onUpdateAddresses} graphData={graphData} onUpdateGraph={onUpdateGraph} entityId={entity?.business_entity_id} />
            </TabPanel>

            <TabPanel value={activeTab} index={3} id="main-website-tab-profile">
                <MainWebsiteTab
                    web_presence={company_details.web_presence}
                    onUpdateWebPresence={onUpdateWebPresence}
                />
            </TabPanel>

            <TabPanel value={activeTab} index={4} id="web-presence-tab-profile">
                <WebPresenceTab
                    web_presence={company_details.web_presence}
                    onUpdateWebPresence={onUpdateWebPresence}
                />
            </TabPanel>

            <TabPanel value={activeTab} index={5} id="liens-tab-profile">
                <LiensTab
                    litigations={litigations}
                    liens={liens}
                    entity={entity}
                    ubos={ubos}
                    onUpdateLiens={onUpdateLiens}
                    onUpdateLitigations={onUpdateLitigations}
                />
            </TabPanel>

            <TabPanel value={activeTab} index={6} id="litigations-tab-profile">
                <LitigationsTab
                    litigations={litigations}
                    entity={entity}
                    ubos={ubos}
                    onUpdateLitigations={onUpdateLitigations}
                />
            </TabPanel>

            <TabPanel value={activeTab} index={7} id="email-tab-profile">
                <EmailTab
                    emails={company_details.emails}
                    onUpdateEmails={onUpdateEmails}
                />
            </TabPanel>

            <TabPanel value={activeTab} index={8} id="phone-tab-profile">
                <PhoneTab
                    onUpdatePhones={onUpdatePhones}
                    phones={company_details.phones}
                />
            </TabPanel>

        </Paper >

    );
}
